import { Block } from '@mote/ui'
import styled, { css, th } from '@xstyled/styled-components'
import { Durations, PlayPauseButton, Scrubber } from '../../shared/components'
import { useMotePlayer } from '../../shared/contexts/motePlayer.context'

export const ReplyPlayer = ({ replyIsMine }) => {
  const { play, pause, playing } = useMotePlayer()

  return (
    <Root layout='horizontal' align='center' gap={12}>
      <StyledPlayPauseButton
        size={48}
        data-testid={playing ? 'pause-button' : 'play-button'}
        aria-label={`${playing ? 'Pause' : 'Play'} (press k)`}
        isPlaying={playing}
        onClick={e => {
          e.stopPropagation()
          playing ? pause() : play()
        }}
        replyIsMine={replyIsMine}
      />

      <Block gap={6} spreadX>
        <StyledScrubber replyIsMine={replyIsMine} />
        <Durations
          divider='/'
          fontSize={12}
          color={replyIsMine ? 'white' : 'black'}
        />
      </Block>
    </Root>
  )
}

const Root = styled(Block)`
  position: relative;
`

const StyledScrubber = styled(Scrubber)`
  .range-slider__track {
    background-color: ${th.color('grey.l3')};
  }

  .range-slider__filled-track {
    background: linear-gradient(
      90deg,
      ${th.color('primaryAlpha.300')} 0%,
      ${th.color('primary.base')} 100%
    );
    opacity: 0.8;
  }

  ${({ replyIsMine }) =>
    replyIsMine &&
    css`
      .range-slider__filled-track {
        background: linear-gradient(
          90deg,
          ${th.color('whiteAlpha.400')} 0%,
          white 100%
        );
      }

      .range-slider__thumb {
        background: white;

        &:focus,
        &[data-focus] {
          box-shadow: outline-primary;
        }
      }
    `};
`

const StyledPlayPauseButton = styled(PlayPauseButton)`
  background-color: white;

  ${({ replyIsMine }) =>
    replyIsMine &&
    css`
      &:focus {
        box-shadow: outline-primary;
      }
    `}
`
